<template>
<nav>
  <ul class="nav nav-pills">
    <li v-if="partnerId">
      <router-link :to="{ name: 'partner', params: {
        partnerId: partnerId
      }}">Partner</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'partner_apps', params: {
        partnerId: partnerId
      }}">Partner Apps</router-link>
    </li>
    <li>
      <router-link :to="{
        name: 'create_partner_app', params: {
        partnerId: partnerId
      }}">New Partner App</router-link></li>
    </li>
    <li v-if="partnerAppId">
      <router-link :to="{ name: 'edit_partner_app', params: {
        partnerId: partnerId,
        partnerAppId: partnerAppId
      }}">Edit Partner App</router-link>
    </li>
  </ul>
</nav>
</template>

<script>
import PartnerAppsStore from '@/stores/PartnerAppsStore'

export default {
  data () {
    return PartnerAppsStore.state
  },

  props: [
    'partnerId', 'partnerAppId'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/PartnerAppNav.vue